// hooks/useSessionTimer.js
import { useState, useRef, useCallback } from 'react';

export const useSessionTimer = () => {
  const [timeRemaining, setTimeRemaining] = useState(1200); // 20 minutes
  const [callEnded, setCallEnded] = useState(false);
  const [timerStarted, setTimerStarted] = useState(false);
  const timerRef = useRef(null);

  const startTimer = useCallback(() => {
    if (!timerStarted) {
      setTimerStarted(true);
      timerRef.current = setInterval(() => {
        setTimeRemaining((prev) => {
          if (prev <= 1) {
            setCallEnded(true);
            if (timerRef.current) {
              clearInterval(timerRef.current);
            }
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [timerStarted]);

  const endSession = useCallback((autoEnd = false) => {
    if (autoEnd) {
      setCallEnded(true);
    }
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);

  const resetTimer = useCallback(() => {
    setTimeRemaining(300);
    setCallEnded(false);
    setTimerStarted(false);
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);

  return {
    timeRemaining,
    callEnded,
    timerStarted,
    startTimer,
    endSession,
    resetTimer
  };
};
